var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('json-viewer',{attrs:{"value":_vm.jsonData,"expand-depth":5,"copyable":{copyText: 'Copiar', copiedText: 'Copiando...', timeout: 2000},"sort":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }